/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The browser build needs supported graphics capabilities: WebGPU or WebGL2. A device or browser without either cannot display the editor. If one workbook fails but a sample works, investigate that file separately instead of repeatedly reloading the page with unsaved work.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器构建需要支持 WebGPU 或 WebGL2。两者都不支持的设备或浏览器无法显示编辑器。如果示例可用而某个工作簿失败，应单独排查该文件，不要在存在未保存内容时反复刷新页面。`)
};

/**
* | output |
* | --- |
* | "The browser build needs supported graphics capabilities: WebGPU or WebGL2. A device or browser without either cannot display the editor. If one workbook fail..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.3.paragraphs.0" }